module.exports = __webpack_public_path__ + "media/images/emblems/Ermatingen-blazon-b98452b12f4532cf52d3ecd1a66b78f7.svg";